<script setup lang="ts">
import { type Ref, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { isNullOrUndefined } from '@metools/tcheck';

import { useAppStore } from '@/stores/app_store';

import { SnackBarTypeEnum } from '@/stores/types';

const appStore = useAppStore();
const { snackbarData } = storeToRefs(appStore);

const snackbarVisible: Ref<boolean> = ref(false);
const snackbarMessage: Ref<string> = ref('');
const snackbarTimeout: Ref<number> = ref(30000);
const snackbarColor: Ref<string> = ref('red');

watch(snackbarData, (newVal) => {
  if (isNullOrUndefined(newVal)) {
    return;
  }

  const message = newVal.message;
  if (message.length <= 0) {
    return;
  }

  snackbarMessage.value = message;
  snackbarTimeout.value = newVal.duration ?? 5000;

  if (newVal.type === SnackBarTypeEnum.Error) {
    snackbarColor.value = 'red';
  } else if (newVal.type === SnackBarTypeEnum.Success) {
    snackbarColor.value = 'green';
  } else {
    snackbarColor.value = 'blue';
  }

  snackbarVisible.value = true;
});

/**
 * Closes the snackbar.
 */
function closeSnackbar() {
  snackbarVisible.value = false;
}
</script>

<template>
  <VSnackbar
    class="myqSnackbar"
    v-model="snackbarVisible"
    :timeout="snackbarTimeout"
    :color="snackbarColor"
    location="top"
  >
    {{ snackbarMessage }}
    <template v-slot:actions>
      <VBtn
        variant="text"
        @click="closeSnackbar"
        class="myqSnackbarButton ml-4 mr-n2"
      >
        Close
      </VBtn>
    </template>
  </VSnackbar>
</template>
